import CertificateSelector from './src/main';

/* istanbul ignore next */
CertificateSelector.install = function(Vue) {
  Vue.component(CertificateSelector.name, CertificateSelector);
};

export default CertificateSelector;
